import { inject, injectable } from 'inversify'
import { SERVICE_TYPES } from '@/core/container/types'
import type { Resolvable } from '@/services/resolvers/types'
import type AccessControlService from '@/services/accessControl/accessControlService'
import type GlobalStateService from '@/services/GlobalStateService'
import type ServerEventsSubscriptionService from '@/services/transport/serverEventsSubscriptionService'
import { LOGOUT_INTERNAL_EVENT } from '@/services/auth/types'
import type SubscriptionService from '@/services/transport/subscriptionService'

@injectable()
export class RootContainerResolver implements Resolvable<unknown> {
  constructor(
    @inject(SERVICE_TYPES.AccessControlService) protected readonly accessControlService: AccessControlService,
    @inject(SERVICE_TYPES.GlobalStateService) protected readonly globalStateService: GlobalStateService,
    @inject(SERVICE_TYPES.SubscriptionService) private readonly subscriptionService: SubscriptionService,
    @inject(SERVICE_TYPES.ServerSubscriptionService)
    protected readonly serverSubscriptionService: ServerEventsSubscriptionService,
  ) {}

  private subscribeKey: string | null = null

  public async resolve() {
    this.subscribeKey = this.subscriptionService.subscribe(LOGOUT_INTERNAL_EVENT, () => {
      this.serverSubscriptionService.disconnectIfConnected()
    })
    await this.accessControlService.install()
    const loadedState = this.globalStateService.getLoadedState()
    if (!loadedState) {
      await this.globalStateService.init()
    }
  }

  public async unresolve() {
    if (this.subscribeKey === null) {
      return
    }
    this.subscriptionService.unsubscribe(this.subscribeKey)
  }
}
